import React from "react";

const StepVerification = ({
  handleVerificationCheck,
  handleResendVerification,
}) => (
  <div className="verification-message">
    <h2 className="register-title">Almost There!</h2>
    <p>
      An email verification link has been sent to your email. Please follow the
      link to finalize your account.
    </p>
    <h3 className="register-title">
      If your browser did not redirect after you verified your email:
    </h3>
    <button onClick={handleVerificationCheck} className="refresh-button">
      I’ve Verified My Email
    </button>
    <p className="register-terms">
      Didn’t receive the email?{" "}
      <button onClick={handleResendVerification} className="resend-button">
        Resend
      </button>
    </p>
  </div>
);

export default StepVerification;
